export default __webpack_public_path__ + "static/portfolio-cover-1-7f07621dfb70c290f1c1ac718bd86262.jpg";